import { useMutation } from '@tanstack/react-query';
import { startLiveSimulation } from '../../queries/LiveSimulations';

export function useStartLiveSimulation() {
  const { mutateAsync, data } = useMutation({
    mutationKey: ['startLiveSimulation'],
    mutationFn: (slug: string) => startLiveSimulation(slug),
    retry: false
  });

  return { mutateAsync, data };
}
